import { css } from 'astroturf';
import React from 'react';

import PostListing from './PostListing';

const styles = css`
  .heading {
    max-width: 50rem;
    margin: 0 auto;
    padding: 0 2rem;
    font-size: calc(20px + 0.8vw);
    font-weight: 900;
    color: #0a1530;
    text-align: center;
  }

  .related {
  margin: 6rem auto 0;
    > p {
      text-align: center;
      margin-bottom: 2rem;
    }
  }
`;

const RelatedPosts = ({ posts }) => {
  if (!posts || !posts.length) {
    return null;
  }

  return (
    <div className={['widePage', styles.related].join(' ')}>
      <h2 className={styles.heading}>Check out these next</h2>
      {posts.length > 1 ? (
        <p>Check out some of our other posts that you might find interesting!</p>
      ) : (
        <p>Check out this other post that you might find interesting!</p>
      )}
      <PostListing postEdges={posts} track="related-post" />
    </div>
  );
};

export default RelatedPosts;
